'use strict'
import InputError from '../../lib/InputError';
import Failed from '../../lib/Failed';

class NewEMail {
    
    constructor() {
        
    }

    init () {
        $('form[name="newemail"]').on('submit', (e) => {
            InputError.reset();
            $('button[type="submit"]').attr('disabled', 'disabled').addClass('disabled');
            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : $('form[name="newemail"]').serialize(),
                success : (data) => {
                    $('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
                    if (data.status === 1){
                        return Failed.success({
                            icon:{
                                type:'icon--success',
                                src:'ic-success-result.svg'
                            },
                            'title':'Nuevo usuario',
                            'description':'Te enviamos un correo electrónico para que puedas modificar tu contraseña.'
                        });
                    }
                    if (data.status === 2){
                        return Failed.show(data.message);
                    }
                    InputError.validate();
                    if (data.error){
                        InputError.show(data.error);
                    }
                },
                error: function(xhr, resp, text) {
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }

    
}

export default NewEMail;